import { useEffect, useState } from "react";

import { BsTrash } from "react-icons/bs";
import { AiOutlineStar, AiFillStar } from "react-icons/ai";
import axios from "axios";
import Swal from "sweetalert2";

import {
  toggleIsMainCatagory,
  insertCatagory,
  deleteCatagory,
  getCatagories,
} from "../../services/adminTourList";

export default function Category() {
  const [tags, setTags] = useState([]);
  const [insertInputs, setInsertInputs] = useState({
    title: "",
    ismain: 0,
  });

  async function toggleIsMain(id) {
    let tag = tags.find((value) => value.id == id);
    let state = tag.ismain == 1 ? 0 : 1;
    let res = await toggleIsMainCatagory(tag.id, state);
    if (res) {
      setTags(
        tags.map((value) => {
          if (value.id == id) return { ...value, ismain: state };
          return value;
        })
      );
    } else {
      Swal.fire({
        title: "خطا!",
        text: "مشکلی پیش آمده، لطفا بعدا امتحان کنید.",
        showConfirmButton: true,
        icon: "error",
      });
    }
  }

  async function insertTag() {
    let res = await insertCatagory(insertInputs);
    if (res) {
      await getTags();
    } else {
      Swal.fire({
        title: "خطا!",
        text: "مشکلی پیش آمده، لطفا بعدا امتحان کنید.",
        showConfirmButton: true,
        icon: "error",
      });
    }
    setInsertInputs({
      title: "",
      ismain: 0,
    });
  }

  function deleteTag(id) {
    Swal.fire({
      title: "حذف دسته بندی",
      text: "آیا میخواهید این دسته بندی را حذف کنید؟",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "بله",
      cancelButtonText: "خیر",
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#198754",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let res = await deleteCatagory(id);
        if (res) {
          setTags(tags.filter((value) => value.id != id));
        } else {
          Swal.fire({
            title: "خطا!",
            text: "مشکلی پیش آمده، لطفا بعدا امتحان کنید.",
            showConfirmButton: true,
            icon: "error",
          });
        }
      }
    });
  }

  async function getTags() {
    let res = await getCatagories();
    setTags(res);
  }

  useEffect(() => {
    getTags();
  }, []);

  return (
    <>
      <div className="modal fade" id="add-category-item">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                اضافه کردن دسته بندی
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div>
                <label htmlFor="title">اسم دسته بندی :</label>
                <input
                  type="text"
                  id="title"
                  className="form-control"
                  value={insertInputs.title}
                  onChange={(e) =>
                    setInsertInputs({ ...insertInputs, title: e.target.value })
                  }
                />
              </div>
              <div className=" form-switch d-flex justify-content-between mt-4 ps-0">
                <label
                  className="form-check-label m-0 p-0"
                  htmlFor="flexSwitchCheckDefault"
                >
                  دسته بندی منتخب
                </label>

                <input
                  className="form-check-input ms-0"
                  type="checkbox"
                  id="flexSwitchCheckDefault"
                  checked={insertInputs.ismain == 1}
                  onChange={() =>
                    setInsertInputs({
                      ...insertInputs,
                      ismain: insertInputs.ismain == 1 ? 0 : 1,
                    })
                  }
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                data-bs-dismiss="modal"
                id="yes"
                onClick={insertTag}
              >
                ثبت
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                انصراف
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="w-100 d-flex justify-content-center justify-content-sm-start">
        <button
          className="btn btn-primary my-3"
          data-bs-toggle="modal"
          data-bs-target="#add-category-item"
        >
          + افزودن دسته بندی
        </button>
      </div>
      <div className="category-container row w-100">
        <div className="col-sm-6 col-12 mb-4 mb-sm-0">
          <div className=" d-flex flex-column mx-3">
            <div className="text-dark text-center">
              <p className=" border-bottom border-3 pb-2  mx-auto border-secondary">
                {" "}
                لیست دست بندی تمامی تورها
              </p>
            </div>
            {tags
              .filter((value) => value.ismain == 0)
              .map((value, index) => (
                <CategoryItem
                  value={value}
                  index={index}
                  deleteTag={deleteTag}
                  toggleIsMain={toggleIsMain}
                />
              ))}
          </div>
        </div>
        <div className="col-sm-6 col-12">
          <div className=" d-flex flex-column mx-3">
            <div className="text-dark text-center">
              <p
                style={{ whiteSpace: "nowrap" }}
                className=" border-bottom border-3 pb-2  mx-auto border-secondary"
              >
                لیست دسته بندی تورهای منتخب
              </p>
            </div>
            {tags
              .filter((value) => value.ismain == 1)
              .map((value, index) => (
                <CategoryItem
                  value={value}
                  index={index}
                  isMain
                  deleteTag={deleteTag}
                  toggleIsMain={toggleIsMain}
                />
              ))}
          </div>
        </div>
      </div>
    </>
  );
}

function CategoryItem({
  value,
  index,
  isMain = false,
  deleteTag,
  toggleIsMain,
}) {
  const backgroundColors = [
    "#787A91",
    "#28b063",
    "#7328b0",
    "#2875b0",
    "#F93970",
    "#AFE575",
  ];

  return (
    <div
      className="category-item d-flex justify-content-between p-2 my-2"
      style={{
        backgroundColor: `${backgroundColors[index % 6]}`,
      }}
      key={`cat-${value.id}`}
    >
      <div>
        <span
          style={{
            width: "30px",
            cursor: "pointer",
            fontSize: "19px",
          }}
          onClick={() => toggleIsMain(value.id)}
        >
          {isMain ? <AiFillStar /> : <AiOutlineStar />}
        </span>
        <span className="ms-2">{value.title}</span>
      </div>
      {![1, 2].includes(parseInt(value.id)) ? (
        <div
          style={{
            width: "30px",
            cursor: "pointer",
            fontSize: "19px",
          }}
          onClick={() => deleteTag(value.id)}
        >
          <BsTrash />
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
